var _path, _circle, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.449,9.292c0-1.63,1.529-2.903,3.231-2.464.859.222,1.562.925,1.784,1.784.34,1.315-.343,2.526-1.422,3.009-.61.273-1.042.83-1.042,1.498v1.356"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17.174,
    r: 0.085
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.614,
    y: 2.614,
    width: 18.771,
    height: 18.771,
    rx: 4.188,
    ry: 4.188
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.725f0cd55381b63c39b90e559071c04c.svg";
export { ForwardRef as ReactComponent };